<template>
    <h6 class="mb-0">{{ titlePage }}</h6>
    <p class="mb-0 text-sm">{{ subtitlePage }}</p>
    <hr class="my-3 horizontal dark" />
    <div class="form-group">
    <label for="name" class="form-label">Name</label>
    <input id="name" type="text" class="form-control" v-model="record.role" />
    </div>
    
    <div class="mt-4 d-flex justify-content-end">
    <button type="button" name="button" class="m-0 btn btn-light" @click="onCancel()">
        Cancel
    </button>
    <button
        type="button"
        name="button"
        class="m-0 btn bg-gradient-success ms-2"
        @click="onSubmit(record)"
    >
        {{ submitButtonName }}
    </button>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        record: {},
      };
    },
    props: {
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        onCancel: { type: Function },
        recordProps: { type: Object }
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
          console.log('Prop changed: ', newVal, ' | was: ', oldVal)
          this.record = newVal
        }
    },
    mounted() {
    
    },
  }
  </script>
  